import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button, Typography } from "@material-ui/core";
import PasswordInput from './PasswordInput';

const useStyles = theme => ({
    element: {
        margin: theme.spacing(1)
    },
    passwordRequirements: {
        color: 'red',
        margin: theme.spacing(1),
        marginBottom: 0
    }
});

const initialState = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
};

const ChangePassword = props => {
    const { classes, containerClass, onSubmit } = props;
    const [state, setState] = useState(initialState);
    const [showPassRequirements, setShowPassRequirements] = useState(false);

    const handleSubmit = () => {
        onSubmit && onSubmit(state);
    };

    return (
        <div className={containerClass}>
            {
                showPassRequirements &&
                <Typography
                    variant="body2"
                    className={classes.passwordRequirements}
                >
                    Hasło musi zawierać co najmniej 1 znak specjalny, 1 cyfrę, 1 wielką i 1 małą literę oraz być nie krótsze niż 8 znaków.
                </Typography>
            }
            <PasswordInput
                label='Stare hasło'
                className={classes.element}
                noValidation
                fullWidth
                onBlur={(value) => setState(state => ({...state, oldPassword: value}))}
            />
            <PasswordInput
                label='Nowe hasło'
                className={classes.element}
                fullWidth
                onBlur={(value) => setState(state => ({...state, newPassword: value}))}
                onBadPassword={(value) => setShowPassRequirements(value)}
            />
            <PasswordInput
                label='Potwierdź hasło'
                className={classes.element}
                fullWidth
                onBlur={(value) => setState(state => ({...state, confirmPassword: value}))}
                onBadPassword={(value) => setShowPassRequirements(value)}
            />
            <Button
                variant='contained'
                color="primary"
                className={classes.element}
                fullWidth
                onClick={handleSubmit}
            >
                Zatwierdź
            </Button>
        </div>
    )
}

ChangePassword.propTypes = {
    containerClass: PropTypes.string,
    classes: PropTypes.object,
    onSubmit: PropTypes.func
}

export default withStyles(useStyles)(ChangePassword);
